import React from 'react';

const DialogHeaderControl = ({ children }) => (
  <div className="ws-ui-dialog-header-control">{children}</div>
);

export default DialogHeaderControl;
